import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Alert, Box, Copy } from '@honda-canada/design-system-react';
const ErrorUI = ({ message }) => (_jsx(Box, { px: "m", children: _jsx(Alert, { dataTestId: "cy-error-message", iconName: "exclamationAlert", iconColor: "white", variant: "error", iconSize: "large", children: _jsx(Copy, { textAlign: "left", size: "extraSmall", color: "white", children: message }) }) }));
export default ErrorUI;
